<mat-card>
  <mat-card-title>Privacy Policy</mat-card-title>

  Golf Games Keeper is the sole owner of all information collected on this website (www.golfgameskeeper.com) and through
  forms and surveys completed by our membership. We will not use, sell, share or rent your personal information to any
  third party, other than in the ways outlined below.
  <br /><br />
  <b>Information submitted at membership registration</b><br />
  Email addresses you provide are kept confidential at all times. It is used for correspondence between our organization
  and you. Similarly, all other information specifically identified as "confidential" within your profile is kept
  secret, for the exclusive use of Golf Games Keeper.
  <br /><br />
  <b>Cookies</b><br />
  Cookies are used only to customize your experience of the website, as a member.
  <br /><br />
  <b>Traffic statistics</b><br />
  Golf Games Keeper keeps track of traffic on the website, based on the visitors' requests, identified by the IP address
  of their computer. This information is always in aggregate form and excludes any personal information. It is used only
  to analyze the general trends of use and preference of the global population of visitors to the site: which pages are
  most visited, how long people stay on each visit, how many visitors come each month, etc.
  <br /><br />
  <b>Contests and surveys</b><br />
  Golf Games Keeper periodically collects information from our visitors through contests and surveys. Participation in
  these is always voluntary and each visitor thus has a choice of which information he or she reveals. Individual info
  is, again, used only to communicate with each participant, for example to inform the winners of their prizes.
  <br /><br />
  <b>Golf Games Keeper.com and other websites</b><br />
  Our websites occasionally point visitors to other websites, not controlled by us. Golf Games Keeper is not responsible
  for these websites and their way of handling confidential information. Therefore, when you click on a link that makes
  you leave our website, we encourage you to check the privacy policy of your destination site, which differ from ours.
  <br /><br />
  <b>Security</b><br />
  Golf Games Keeper has taken rigorous measures for protecting the security and integrity of member-related information
  in order to avoid its loss, corruption, and misuse or inadvertent modification.
  <br /><br />
  <b>Right of access</b><br />
  Each member of Golf Games Keeper has a right to access and modify whatever personal data is kept in our database. This
  access is provided through the website itself, by simply logging on and visiting the "Modify my profile" page. At any
  given time, you can have access to the public and private information contained in your profile, and modify them if
  necessary.
  <br /><br />
  <b>Usernames and Passwords</b><br />
  All Golf Games Keeper Members are required to keep their usernames and passwords confidential at all times. Any member
  may change their username and password at any time and we recommend changing this information on a regular basis to
  increase security. Sharing or distribution of your personal username and password with any other person or entity is
  strictly prohibited. It is the Members responsibility to protect this information and keep it confidential.
  <br /><br />
  <b>Address Book (Roster)</b><br />
  The information contained within our Membership Roster is PRIVATE and CONFIDENTIAL and is solely for use by our
  active, paid Members to contact other Members for the purpose of networking within the group. This information is to
  remain confidential and names, phone numbers and email address contained herein is not to be used without the express
  consent of the member and/or Golf Games Keeper. Use of this personal information for any purpose other than networking
  within the group is strictly prohibited and is grounds for immediate termination from Golf Games Keeper and possible
  legal action.
  <br /><br />
  <b>Payment Information</b><br />
  Golf Games Keeper does NOT collect any information nor does it store any transaction information within the website
  when a Member makes a purchase using the Golf Games Keeper payment interface. Golf Games Keeper uses a secure, 3rd
  party credit card processing company to process all transactions. This is why you must re-enter all payment
  information each time you make a purchase or reservation through the Golf Games Keeper website. We do not store any
  information required by the host processing company to make an online payment.
  <br /><br />
  <b>Contact the administrators</b><br />
  Should you wish to clarify certain points concerning this privacy policy, or should you have any question or complaint
  concerning Golf Games Keeper websites, please contact us immediately at <a
    href="mailto:info@golfgameskeeper.com">info&#64;golfgameskeeper.com</a>.
  <br /><br />
  <b>Advertisers</b><br />
  Golf Games Keeper, LLC actively solicit third party advertisers to engage with our Membership for the purpose of
  providing information about their respective, products, services, and promotions that may be of interest to our
  Members. Engagement is voluntary and is initiated solely by the Member clicking a link or ad on the Golf Games Keeper
  App or Website. Golf Games Keeper does not supply any Member information to our advertisers. A Member visiting a third
  party website may be asked for personal information for use by the advertiser. Providing your personal information to
  a third party vendor is solely at your discretion and in no way is an endorsement by Golf Games Keeper nor is Golf
  Games Keeper liable for any information, product, service offered by the vendor. Always read the Terms and Conditions,
  EULA’s and Privacy Policies of all third party vendors carefully before providing any type of personal information.
  Golf Games Keeper is not responsible for any issues arising from you providing your personal information, making
  purchases, signing agreements or contracts with any third party vendor.<br /><br />
  Golf Games Keeper, LLC.<br />Contact Customer Service: info&#64;golfgameskeeper.com.
  <br /><br />

</mat-card>